// @tennis-matches/core/ui-globals
// Mobile burger menu navigation
// Used by all apps for consistent mobile menu behavior

let __installed = false;

function toggleBurgerMenu(open) {
  const burger = document.querySelector("[data-burger]");
  if (!burger) return;

  const nav = document.querySelector("[data-nav]");
  const topbarRight = nav?.closest(".topbar__right");

  burger.setAttribute("aria-expanded", String(open));

  if (topbarRight) {
    if (open) {
      topbarRight.classList.add("nav--open");
    } else {
      topbarRight.classList.remove("nav--open");
    }
  }
  if (nav) {
    if (open) {
      nav.classList.add("nav--open");
    } else {
      nav.classList.remove("nav--open");
    }
  }
  if (open) {
    burger.classList.add("topbar__burger--active");
  } else {
    burger.classList.remove("topbar__burger--active");
  }
}

export function installBurgerMenuNavigation({ navigateTo } = {}) {
  if (__installed) return;
  __installed = true;

  // --- Burger Menu Toggle -------------------------------------
  document.addEventListener("click", (e) => {
    const burger = e.target.closest("[data-burger]");
    if (!burger) return;

    e.preventDefault();
    e.stopPropagation();

    const isExpanded = burger.getAttribute("aria-expanded") === "true";
    toggleBurgerMenu(!isExpanded);
  });

  // Intercept navigation links and use History API
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[data-nav-link], a[href^='#'], a[href^='/']");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href) return;

    // Handle hash links (#route) and path links (/route)
    if (href.startsWith("#") || (href.startsWith("/") && !href.startsWith("//"))) {
      e.preventDefault();
      let route;
      
      if (href.startsWith("#")) {
        route = href.slice(1);
      } else {
        // Handle path links
        const path = href.slice(1); // Remove leading "/"
        // Map "/" to "home", otherwise use the path as route name
        route = path === "" || path === "/" ? "home" : path;
      }
      
      // Get route name from data-nav-link attribute if available (more reliable)
      const navLinkRoute = link.getAttribute("data-nav-link");
      if (navLinkRoute) {
        route = navLinkRoute;
      }
      
      if (typeof navigateTo === "function") {
        navigateTo(route);
      }
    }
  });

  // Close burger menu when clicking on a nav link (mobile)
  document.addEventListener("click", (e) => {
    const navLink = e.target.closest(".nav-link");
    if (!navLink) return;

    if (window.innerWidth <= 780) {
      const burger = document.querySelector("[data-burger]");
      if (burger && burger.getAttribute("aria-expanded") === "true") {
        toggleBurgerMenu(false);
      }
    }
  });

  // Close burger menu when clicking outside (mobile)
  document.addEventListener("click", (e) => {
    const burger = document.querySelector("[data-burger]");
    if (!burger) return;

    const isExpanded = burger.getAttribute("aria-expanded") === "true";
    if (!isExpanded || window.innerWidth > 780) return;

    // Don't close if clicking on burger button or inside the menu
    const clickedInside = e.target.closest("[data-burger]") ||
      e.target.closest(".topbar__right") ||
      e.target.closest(".nav-link");

    if (clickedInside) return;

    // Close the menu
    toggleBurgerMenu(false);
  });
}
